import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { YMInitializer } from "react-yandex-metrika";
import ContextWorker, { THEME_TYPE } from "../../contextWorker";
import { GlobalContext } from "../../context";
import { get } from "lodash";
import { metricsHost, metricsID } from "../../utils/metrics";

const options = {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: false,
};
const YaMetrika = () => {
  ContextWorker();
  const { context } = useContext(GlobalContext);
  const globalTheme = get(context, "globalTheme");
  const location = useLocation();

  const domain = window?.location?.origin;

  if (location.pathname === "/esia") {
    const metricIDs = [metricsID.REGION];

    /** Для ЯНАО дополнительная метрика */
    if (domain === metricsHost.YANAO) {
      metricIDs.push(metricsID.YANAO);
    }

    return <YMInitializer accounts={metricIDs} options={options} version="2" />;
  }

  if (location.pathname === "/") {
    const metricIDs = [metricsID.MSK];

    /** Для ЯНАО дополнительная метрика */
    if (domain === metricsHost.YANAO) {
      metricIDs.push(metricsID.YANAO);
    }

    return <YMInitializer accounts={metricIDs} options={options} version="2" />;
  }

  if (location.pathname === "/choice") {
    const metricIDs = [metricsID.MSK];

    /** Для ЯНАО дополнительная метрика */
    if (domain === metricsHost.YANAO) {
      metricIDs.push(metricsID.YANAO);
    }

    return <YMInitializer accounts={metricIDs} options={options} version="2" />;
  }

  const account =
    globalTheme === THEME_TYPE.ESIA ? metricsID.REGION : metricsID.MSK;

  return <YMInitializer accounts={[account]} options={options} version="2" />;
};

export default YaMetrika;
